import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  LOCALE_ID,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { RenderedService } from "../../rendered.service";
import { BaseScaffoldComponent } from "../base-scaffold/base-scaffold.component";
import { CourseService } from "@scaffold/services/course.service";
import { ItemsService } from "@scaffold/services/items.service";
import { ActivatedRoute } from "@angular/router";
import { ConfirmDialog } from "@generic/confirm-dialog/confirm-dialog.component";
import { ViewUpdateService } from "@scaffold/services/view-update.service";
import { NbDialogService, NbTreeGridComponent } from "@nebular/theme";
import { formatDate } from "@angular/common";
import { searchObject } from "@app/framework/search-bar/search-bar.component";
import { Subject } from "rxjs";
import { debounceTime, take, takeUntil } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import { TranslationService } from "@services/translation.service";
import cloneDeep from "lodash/cloneDeep";

@Component({
  selector: "scaffold-data-table",
  templateUrl: "./data-table.component.html",
  styleUrls: ["../../rendered.component.scss", "./data-table.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataTableComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  /**
   * @fileoverview data table that displays a data object list or properties of a single data object
   */
  view;
  public destroy$: Subject<boolean> = new Subject<boolean>();
  @ViewChild(NbTreeGridComponent) table: NbTreeGridComponent<any>;
  private _listObservable;
  private isCopying = false;
  table_value = [];
  columns = [];
  searchTerms = [];
  totals = {};
  columnData = [];
  columnValues = [];
  orderBy;
  orderDirection;
  searchData: searchObject;
  @Output() change = new EventEmitter<any>();
  tableSortData = {
    param: undefined,
    direction: 1,
  };
  originalItems;
  resetSubsription;
  changeDetection;
  private _active: number = 1;
  route: ActivatedRoute;
  element: any;
  isLoading: boolean = false;
  set active(page: number) {
    console.log(page);
    this._active = page;
    this.getListItems();
    this.redraw();
  }
  get active(): number {
    return this._active;
  }
  perPage = 10;
  itemCount = 0;

  /**
   *
   * @param cdr ''
   * @param renderedService ''
   * @param courseService ''
   * @param itemsService ''
   * @param activatedRoute ''
   * @param dialog ''
   * @param viewUpdate ''
   * @param locale ''
   */
  constructor(
    private translationService:TranslationService,
    private translateService: TranslateService,
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private courseService: CourseService,
    private itemsService: ItemsService,
    public activatedRoute: ActivatedRoute,
    public dialog: NbDialogService,
    private viewUpdate: ViewUpdateService,
    @Inject(LOCALE_ID) private locale: string
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    this.viewUpdate
    .registerListUpdate()
    .pipe(takeUntil(this.destroy$))
    .subscribe((data) => {
      if((data?.added||data?.updated) &&data.type === this.item.list_view&&this.item.data_source === "list"){
        this.getListItems();
      }
    })
    if (!this.item.pageCounts) {
      if (this.item.perPage) {
        this.item.pageCounts = [{ count: this.item.perPage }];
      } else {
        this.item.pageCounts = [{ count: this.perPage }];
      }
    }
    this.perPage = this.item.pageCounts[0].count;
    this.item.columns.forEach((col) => {
      console.log(this.columns);
      if (!this.columns.includes(col.label)) {
        if (!col?.data?.match(/\./)) {
          this.searchTerms.push(col);
        }
        this.columns.push(col?.label);
        this.totals[col?.label] = [];
        this.columnData.push(col);
        if (col?.data && Object.keys(col.data).length >= 1)
          this.columnValues.push(col.data);
      }
    });
    if (!this.item.value) {
      this.item.value = [];
    }
    this.columns.push("Delete");

    if (this.item.data_source === "list") {
      if (!this.item.search_load) {
        this.getListItems(true);
      }
    }

    this.originalItems = cloneDeep(this.item.value);
    this.itemsService
      .registerReset()
      .pipe(takeUntil(this.destroy$))
      .subscribe((r) => {
        console.log(r);
        console.log(this.table_value, this.originalItems);
        if (r === "reset") {
          this.tableSortData = {
            param: undefined,
            direction: 1,
          };
          this.table_value = [];
          this.table_value = cloneDeep(this.originalItems) || [];
          this.cdr.markForCheck();
        } else if (r === "saved") {
          this.originalItems = cloneDeep(this.table_value);
        }
      });
  }
 
  filterColumns() {
    return this.columns.filter((c,i) => {
      let hide = false;
      const columnData = this.item.columns[i];
      if (columnData?.no_null_value) {
        let foundValue = false;
        this.view.forEach((v) => {
          if (v.data.hasOwnProperty(columnData.data)) {
            foundValue = true;
          }
        });
        if(!foundValue){
          hide = true;
        }
      };
      return !hide;
    });
  }
 
  get hasFilters() {
    return this.search;
  }

  /**
   *
   * @param item ''
   */
  getURL(item) {
    if (!item) return "";
    let _rel_url = "";
    if (
      this.activatedRoute &&
      this.activatedRoute.parent &&
      this.activatedRoute.parent.component
    ) {
      this.activatedRoute.parent.url.subscribe((val) => {
        const parts = val.map((v) => {
          return v.path;
        });
        _rel_url = "/" + parts.join("/") + "/";
        _rel_url += item?.type + "/" + item?.id;
      });
    } else {
      _rel_url = "/";
      _rel_url += item?.type + "/" + item?.id;
    }
    return _rel_url;
  }

  /**
   *
   * @param count
   */
  setPageCount(count) {
    this.perPage = count;
    this.active = 1;
  }
  /**
   *
   * @param data
   */
  search(data: searchObject) {
    this.searchData = data;
    this._active = 1;
    this.getListItems();
  }
  getCountLabel() {
    if(!this.itemCount)return''
    const of = this.translationService.getTranslatedContent('of','of')
    const items = this.translationService.getTranslatedContent('items','Items')
    const start = this.active * this.perPage - this.perPage + 1;
    const end = Math.min(this.active * this.perPage, this.itemCount);
    const { itemCount: itemCount1 } = this;
    return `${start} - ${end} ${of} ${itemCount1} ${items}`;
  }

  /**
   *
   * @param items''
   */
  processItems(items) {
    if (!items?.listItems) {
      items = { listItems: [items], currentPage: 0, totalItems: 1 };
    }
    items?.listItems.forEach((v, i) => {
      if (v) {
        if (this.item && this.item?.type === "data_table") {
          this.item.columns.forEach((col) => {
            let found = false;
            this.totals[col.label].forEach((dat) => {
              if (dat?.value === v?.data?.[col?.data]) {
                found = true;
                dat.count++;
              }
            });
            if (!found) {
              this?.totals?.[col?.label].push({
                value: v?.data?.[col?.data],
                count: 1,
              });
            }
          });
        }
      }
    });
    this.itemCount = items?.totalItems || items?.listItems?.length;
    this.view = items?.listItems?.map((item) => {
      if (!item.data) return item;
      item.data.id = item.id;
      item.data.shownDataType = item.data.type;
      item.data.type = item.type;
      return item;
    });
    this.cdr.markForCheck();
  }
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  handleCopy(event: ClipboardEvent): void {
    this.isCopying = true;
    setTimeout(() => (this.isCopying = false), 300);
  }

  openLinkRow(event, data) {
    event?.stopPropagation();
    if (event.type !== "click" || this.isCopying) return;
    if (!this.item?.["row_link"]) return;
    let openLocation = this?.item?.link_location || "view";
    this.renderedService.openLinkHandler(
      event,
      data,
      openLocation === "modal" ? null : this.activatedRoute,
      openLocation === "modal" ? "item_link" : null,
      this.item?.autosave_modal,
      this.item?.modal_width_size
    );

    this.itemsService
      .registerItem(data)
      .pipe(takeUntil(this.destroy$), debounceTime(100))
      .subscribe((d) => {
        if (d && this.item.autosave_modal) {
          this.view = this.view.map((item) =>
            item.id !== data.id
              ? item
              : { ...item, data: { ...item.data, ...d } }
          );
          this.redraw();
        }
      });
  }

  openLink(event, data) {
    event?.stopPropagation();
    let openLocation = this?.item?.link_location || "view";
    this.renderedService.openLinkHandler(
      event,
      data,
      openLocation === "modal" ? null : this.activatedRoute,
      openLocation === "modal" ? "item_link" : null,
      this.item?.autosave_modal
    );

    this.itemsService
      .registerItem(data)
      .pipe(takeUntil(this.destroy$), debounceTime(100))
      .subscribe((d) => {
        if (d && this.item.autosave_modal) {
          this.view = this.view.map((item) =>
            item.id !== data.id
              ? item
              : { ...item, data: { ...item.data, ...d } }
          );
          this.redraw();
        }
      });
  }
  getListItems(isInitialCall?) {
    this.isLoading = true;
    if (this._listObservable) {
      this._listObservable.unsubscribe();
    }
    if (isInitialCall) {
      this.orderBy = this.item.allow_field_sort_init
        ? this.item.field_sort_init
        : this.columnValues?.[0] || "";
      this.orderDirection = this.item.allow_field_sort_init
        ? this.item.field_sort_init_direction
        : "ASC";
      this.tableSortData.param = this.orderBy;
      this.tableSortData.direction = this.orderDirection === "ASC" ? 1 : -1;
    }
    const query = "";
    let base = {};

    base = this.item.list_view;
    let url = "courses/" + this.courseService.id + "/" + base;

    if (this.info) {
      if (this.info.type && this.info.id) {
        url = this.info.type + "/" + this.info.id + "/" + base;
      } else {
        url = "" + base;
      }
    }
    url += "?output=dataonly&mode=list";
    if (!this.item?.avoid_paginating)
      url += "&pageNumber=" + (this.active - 1) + "&perPage=" + this.perPage;

    if (
      this.item?.filter_data &&
      this.item?.filter_list_field?.queries?.length
    ) {
      let { queryKeys, queryValues, queryOperations } =
        this.item.filter_list_field.queries.reduce(
          (acc, query) => {
            acc.queryKeys.push(query.key);
            acc.queryValues.push(query.text);
            acc.queryOperations.push(query.operation);
            return acc;
          },
          { queryKeys: [], queryValues: [], queryOperations: [] }
        );

      url += `&queryKeys=${queryKeys.join(",")}&queryValues=${queryValues.join(
        ","
      )}&queryOperations=${queryOperations.join(",")}&queryOperand=${
        this.item?.filter_list_field.queryConditional
      }`;
    }
    if (this.columnValues) {
      url += "&key_values=" + this.columnValues.join(",");
    }
    if (this.item.linked) {
      url += "&data_items=linked";
    }
    if (this.searchData && this.searchData.key != null) {
      url +=
        "&searchParam=" +
        this.searchData.key +
        "&searchTerm=" +
        encodeURIComponent(this.searchData.term);
    }
    if (this.orderBy) {
      url += "&orderBy=" + this.orderBy + "&direction=" + this.orderDirection;
    }

    if (this.searchData?.itemState && !this.item.force_only_active_items) {
      url += `&state=${this.searchData.itemState}`;
    }

    if (this.item.force_only_active_items) {
      url += `&state=active`;
    }

    this._listObservable = this.courseService.get(url).subscribe((co) => {
      this.isLoading = false;
      if (typeof co === "object" && Object.keys(co).length >= 1) {
        this.processItems(co);
      } else {
        this.itemCount = 0;
        this.cdr.detectChanges();
      }
    });
    return url;
  }

  /**
   *
   * @param item ''
   * @param arr ''
   */
  addRow(item, arr) {
    console.log(arr);
    const ne = {};
    arr.push(ne);

    this.table.renderRows();
    this.changed();
  }

  /**
   *
   * @param row
   * @param arr
   */
  deleteRow(row, arr) {
    arr.splice(arr.indexOf(row), 1);
    this.table.renderRows();
    this.changed();
  }

  /**
   *
   * @param item
   */
  deleteItem($event, item) {
    $event.preventDefault();
    $event.stopPropagation();
    console.log(item);
    const settings: any = {
      context: {
        data: {
          title: this.translationService.getTranslatedContent('delete_item',"Delete Item")+"?",
          message: this.translationService.getTranslatedContent('are_you_sure_you_want_to_delete_this_item',"Are you sure you want to delete this item")+"?",
          confirmMessage: this.translationService.getTranslatedContent('delete',"Delete"),
          size: "half",
        },
      },
    };
    const dialogRef = this.dialog.open(ConfirmDialog, settings);

    dialogRef.onClose.subscribe((result) => {
      if (result) {
        this.deleteHandler(item);
      }
    });
  }

  /**
   *
   * @param item
   */
  editItem(item, $event?) {
    $event?.stopPropagation();
    this.renderedService.openView(this.item.edit_mode || "read", item);
  }

  deleteHandler(item) {
    const path = "/" + item.type + "/" + item.id;

    this.itemsService.deleteData(path).subscribe((d) => {
      // if the last item has been deleted and on the last page, then set to previous page
      if((d.status==='deletd'||d.status==='deleted')&&(this.active>1&&this.view.length<=1)){
        this._active = this.active -1;
      }
      this.viewUpdate.triggerListChange({
        list_type: "list",
        type: item.type,
        removed: item.id,
      });
      this.getListItems();
    });
  }

  getTitle(col) {
    const translation = this.translateService.instant("sort_by");
    return `${translation} ${col.label}`;
  }

  getData(data, type, col, element) {
    try{
      if (data) {
        if (type === "date"&& data) return formatDate(data, "MM/dd/yyyy", this.locale);
        if (type === "datetime"&& data)
          return formatDate(data, "MM/dd/yyyy h:mm a", this.locale);
        if (type === "check_mark")
          return data
            ? '<nb-icon pack="far" icon="check-circle">check</i>'
            : "";
        if (type === "percent")
          return !isNaN(+data) ? (data * 100).toFixed(2) + "%" : "";
      }
    if (col?.data === "type" && element?.data?.shownDataType) {
      data = element?.data?.shownDataType;
    }
    if(!data&&col.translation_key_default){
      let content = this.translationService.getTranslatedContent(col.translation_key_default);
      if(content){
        if(col.text_transform){
          content=this.translationService.transform(content,col.translation_key)
        }
        return content

      }

    }

    if (col?.default_value && !data) {
      return col.default_value_text;
    }
    if (data === undefined || data === null) data = "";
    if (col?.map_value && col?.values_to_map?.length) {
      col?.values_to_map?.forEach(({ fromValue, toValue }) => {
        console.log(data);
        toValue = this.checkForTranslation(toValue)
        if (!fromValue && !data) {
          data = toValue;
        }
        if (fromValue) {
          const reg = new RegExp(fromValue, "gim");
          // make into string value
          data = data + "";
          data = data.replace(reg, toValue);
        }
      });
    }
    return data;
  }catch(error){
    return data
  }
  }

  capitalizeEachWord(input) {
    if(typeof input!=='string')return input
    const words = input.split(" ");
    const capitalizedWords = words.map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1)
    );
    return capitalizedWords.join(" ");
  }

  checkForTranslation(input){
    const pattern = /\[\s*([^|\]]*?)\s*\|\s*translation\s*(?:\|\s*([^|\]]*?)\s*)?]/g;
    if(!pattern.test(input))return input
    return !input.replace? input : input.replace(pattern, (_, key, additionalFormatArgs) => {
      const trimmedKey = key.trim();
      let content = this.translateService.instant(trimmedKey);
      if (!content) return trimmedKey;
      additionalFormatArgs = additionalFormatArgs?.trim();
      if (additionalFormatArgs === "uppercase") content = content.toUpperCase();
      if (additionalFormatArgs === "lowercase") content = content.toLowerCase();
      if (additionalFormatArgs === "capitalize")
        content = this.capitalizeEachWord(content);
      return content;
    })  
  }

  /**
   *
   * @param $event ''
   * @param element ''
   * @param col ''
   */
  editTableValue($event, element, col) {
    const ind = this.table_value.indexOf(element);
    const key = this.item.name + "." + ind + "." + col.data;
    console.log(this.item);
    console.log(col);
    console.log(key);
    console.log($event);
    console.log(element);
    this.changed();
  }

  /**
   *
   * @param data ''
   */
  getCursor(data) {
    return data.match(/\./) ? "unset" : "pointer";
  }

  /**
   *
   * @param data ''
   */
  sortTable(data) {
    // disable sort if the data key references another object. We may add support for this later
    if (data.match(/\./)) {
      return false;
    }
    if (this.tableSortData.param === data) {
      this.tableSortData.direction *= -1;
    } else {
      this.tableSortData.param = data;
      this.tableSortData.direction = 1;
    }
    if (this.view) {
      this.orderBy = data;
      this.orderDirection = this.tableSortData.direction > 0 ? "ASC" : "DESC";
      this._active = 1;
      this.getListItems();
    } else {
      if (this.table_value) {
        console.log("sorting data by", data);
        this.table_value.sort((a, b) => {
          let sorted = 0;
          if (a[data] > b[data] || !a[data]) {
            sorted = this.tableSortData.direction;
          } else {
            sorted = -1 * this.tableSortData.direction;
          }

          if (a[data] === b[data]) {
            sorted = 0;
          }
          return sorted;
        });
        this.changed();
      }
    }
    this.table.renderRows();
  }

  changed() {
    this.change.emit({ value: this.table_value });
  }
  update() {
    console.log("update", this.value);
    if (JSON.stringify(this.value) !== JSON.stringify(this.table_value))
      this.table_value = this.value || [];
  }
}
